// extracted by mini-css-extract-plugin
export default {"main":"adminLayout_main__d7uqn"};